import React from 'react';

const GLicon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.33366 3.99984H0.666992V15.6665C0.666992 16.5832 1.41699 17.3332 2.33366 17.3332H14.0003V15.6665H2.33366V3.99984ZM15.667 0.666504H5.66699C4.75033 0.666504 4.00033 1.4165 4.00033 2.33317V12.3332C4.00033 13.2498 4.75033 13.9998 5.66699 13.9998H15.667C16.5837 13.9998 17.3337 13.2498 17.3337 12.3332V2.33317C17.3337 1.4165 16.5837 0.666504 15.667 0.666504ZM14.8337 8.1665H6.50033V6.49984H14.8337V8.1665ZM11.5003 11.4998H6.50033V9.83317H11.5003V11.4998ZM14.8337 4.83317H6.50033V3.1665H14.8337V4.83317Z" fill="currentColor"/>
    </svg>
  )
}

export default GLicon;